export const DASHBOARD = "/panel";
export const FIELD_MARKUP = "/panel/markup/field/:videoId";
export const EXERCISES = "/panel/exercises/:videoId";
export const REGISTER = "/panel/register";
export const LOGIN = "/panel/login";
export const TRACK_MATCHING = "/panel/markup/track/:videoId";
export const SUPER_TRACKS_MARKUP = "/panel/markup/super-tracks/:videoId";
export const SUPER_TRACK_MARKUP =
  "/panel/markup/super-tracks/:videoId/markup/:trackId";
export const EVENTS_RESOLVING = "/panel/events-resolving/:videoId";
export const NOT_FOUND = "*";
export const LABELER = "/panel/labeler";
export const INTERN = "/panel/intern";
export const INTERN_CONFLICTS = "/panel/intern/tracks";
export const INTERN_EVENTS = "/panel/intern/events-resolving";
export const MANAGER = "/panel/manager";
export const VALIDATION = "/panel/events-validation/:videoId";
export const EVENTS = "/panel/events-tagging/:videoId";
export const TASKS = "/panel/tasks";
export const ORDERS = "/panel/orders";
export const VIDEOS = "/panel/videos";
export const SUMMARY = "/panel/summary";
export const EVENT_LIGHT = "/panel/event-light/:videoId";
